var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #00cc87;\n      }\n\n      .st1 {\n        fill: #3852a5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.64,53.25c.7.71,1.63,1.11,2.64,1.11.56,0,1.09-.12,1.57-.34l-.32,4.13-.62,6.18,7.27,7.27,1.15-11.73c.03-.36.31-.62.68-.62h3.31c.35,0,.65.27.68.62l1.35,14.1,7.29-7.29-.84-8.52-1.69-18.41h16.7v-7.48H29.85c-2.02,0-3.76.72-5.18,2.14l-7.33,7.29c-1.41,1.46-1.41,3.83.02,5.29l6.28,6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.11,40.53l-.65,7-3.17-3.17,3.82-3.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.34,39.75h-.53v-7.48h.53c2.07,0,3.75,1.67,3.75,3.73s-1.68,3.75-3.75,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.15,24.8c0-3.58,2.92-6.5,6.5-6.5s6.5,2.92,6.5,6.5-2.92,6.5-6.5,6.5-6.5-2.92-6.5-6.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.71,21.09c.29.29.37.72.22,1.09s-.52.62-.92.62h-29.19v7.48h-2V2.06c0-.55.45-1,1-1s1,.45,1,1v2.41h29.19c.4,0,.77.24.92.62.15.37.07.8-.22,1.09l-7.46,7.46,7.46,7.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.46,46.77v13.75c0,.4-.24.76-.62.92-.37.15-.8.07-1.09-.22l-2.83-2.83-36.26,36.25c-.19.19-.44.3-.71.3s-.52-.11-.7-.3l-17.61-17.63-11.28,11.28c-.39.39-1.02.39-1.41,0l-6.67-6.63c-.18-.19-.29-.44-.29-.71s.1-.52.29-.7l18.65-18.65c.19-.19.45-.3.71-.3s.52.11.71.29l5.31,5.31,7.27,7.27,5.02,5.03,2.64-2.64,1.84-1.84,3.64-3.64,1.82-1.82,13.92-13.92,2-2,3.03-3.03-2.83-2.84c-.08-.08-.15-.18-.2-.28v3.32l-2,2v-10.76h2v4.59c.16-.35.52-.57.9-.57h13.75c.55,0,1,.45,1,1h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.7f1b683f71d71fdc814795661a908316.svg";
export { ForwardRef as ReactComponent };